import PageHero from '@/components/site/PageHero';
import SectionHeading from '@/components/site/SectionHeading';
import CtaBand from '@/components/site/CtaBand';
import StatsBand from '@/components/sections/StatsBand';
import WhyChooseUs from '@/components/sections/WhyChooseUs';
import Reveal from '@/components/ui/Reveal';
import { usePage } from '@site/content';

export default function About() {
  const page = usePage('about');
  const home = usePage('home');
  const { hero, story, founder, values } = page;

  return (
    <>
      <PageHero {...hero} />

      <section className="py-16 sm:py-24">
        <div className="site-container grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <SectionHeading eyebrow={story.eyebrow} title={story.title} />
            <p className="mt-5 text-pretty leading-relaxed text-ink-600">{story.paragraph1}</p>
            <p className="mt-4 text-pretty leading-relaxed text-ink-600">{story.paragraph2}</p>
          </div>
          <Reveal>
            <img src={story.image} alt={story.imageAlt} loading="lazy" className="aspect-[4/3] w-full rounded-[2rem] object-cover" />
          </Reveal>
        </div>
      </section>

      <StatsBand stats={home.stats} />

      <section className="py-16 sm:py-24">
        <div className="site-container grid gap-12 lg:grid-cols-[1fr_1.2fr] lg:gap-16">
          <Reveal className="relative">
            <div className="overflow-hidden rounded-[2rem] bg-gradient-to-b from-ink-100 to-ink-200">
              <img src={founder.image} alt={founder.imageAlt} loading="lazy" className="w-full object-cover" />
            </div>
          </Reveal>
          <div className="flex flex-col justify-center">
            <p className="eyebrow">{founder.eyebrow}</p>
            <h2 className="mt-3 text-4xl leading-none text-ink-950 sm:text-6xl">{founder.name}</h2>
            <p className="mt-2 text-primary-600">{founder.role}</p>
            <p className="mt-6 text-pretty leading-relaxed text-ink-600">{founder.paragraph1}</p>
            <p className="mt-4 text-pretty leading-relaxed text-ink-600">{founder.paragraph2}</p>
            <figure className="mt-8 grid items-center gap-4 rounded-2xl border border-[var(--app-border)] bg-white p-3 sm:grid-cols-[12rem_1fr]">
              <img src={founder.awardImage} alt={founder.awardAlt} loading="lazy" className="aspect-[4/3] w-full rounded-xl object-cover" />
              <figcaption className="p-2 text-sm text-ink-600">
                <span className="block font-display text-xl font-bold uppercase text-ink-950">Atal Bharat Gaurav Samman</span>
                National award, Atma Nirbhar category
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

      <div className="bg-ink-50">
        <WhyChooseUs eyebrow={values.eyebrow} title={values.title} items={home.why.items} />
      </div>
      <CtaBand />
    </>
  );
}
